// src/event-bus.ts
import Vue from 'vue';
import { UAParser } from 'ua-parser-js';
class EventBusClass extends Vue {
  constructor() {
    super();
    this.deviceWidth = 0;
    this.deviceHeight = 0;
    this.deviceIsMobile = false;
    this.deviceIsTablet = false;
    this.deviceIsMobileOnly = false;
    this.emitPageResize = this.emitPageResize.bind(this); // 👈 Importante in TS per il listener
    window.addEventListener('resize', this.emitPageResize, false);
    this.emitPageResize(); // emit subito all'avvio
  }
  emitPageResize() {
    const device = this.getDeviceData();
    this.deviceWidth = device.width;
    this.deviceHeight = device.height;
    this.deviceIsMobile = device.isMobile;
    this.deviceIsTablet = device.isTablet;
    this.deviceIsMobileOnly = device.isMobileOnly;
    const payload = {
      width: this.deviceWidth,
      height: this.deviceHeight,
      isMobile: this.deviceIsMobile,
      isTablet: this.deviceIsTablet,
      isMobileOnly: this.deviceIsMobileOnly
    };
    this.$emit('page-resize', payload);
  }
  getDeviceData() {
    const parser = new UAParser();
    const device = parser.getDevice();
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: device.type === 'mobile' || device.type === 'tablet',
      isTablet: device.type === 'tablet',
      isMobileOnly: device.type === 'mobile'
    };
  }
}
export const EventBus = new EventBusClass();